// AWS / Cognito config (set via .env)
export const awsRegion = process.env.REACT_APP_AWS_REGION || 'us-east-1';

const userPoolId = process.env.REACT_APP_USER_POOL_ID || 'PLACEHOLDER_USER_POOL_ID';
export const Authority =
  process.env.REACT_APP_AUTHORITY ||
  `cognito-idp.${awsRegion}.amazonaws.com/${userPoolId}`;
export const UserPoolClientId =
  process.env.REACT_APP_USER_POOL_CLIENT_ID || 'PLACEHOLDER_CLIENT_ID';
export const CognitoDomain =
  process.env.REACT_APP_COGNITO_DOMAIN || '';
export const IdentityPoolId =
  process.env.REACT_APP_IDENTITY_POOL_ID || 'PLACEHOLDER_IDENTITY_POOL_ID';

// S3 buckets
export const SourceBucket =
  process.env.REACT_APP_SOURCE_BUCKET || 'PLACEHOLDER_SOURCE_BUCKET';
export const OutputBucket =
  process.env.REACT_APP_OUTPUT_BUCKET || 'PLACEHOLDER_OUTPUT_BUCKET';

// API Gateway endpoint that wraps the Lambda
export const AnalyzerApiUrl =
  process.env.REACT_APP_ANALYZER_API_URL || 'PLACEHOLDER_API_URL';



// Theme palette (matches existing PDF UI)
export const HEADER_BACKGROUND = '#17134B';
export const PRIMARY_MAIN = '#5F5BCD';
export const SECONDARY_MAIN = '#54FBF5';
export const SIDEBAR_BACKGROUND = '#2c3e50';

// Polling
export const POLL_INTERVAL_MS = 15_000;
export const MAX_POLL_ATTEMPTS = 120; // 30 min

// S3 key prefixes produced by the Lambda
export const OUTPUT_PREFIX = 'remediation_analyzer/results/';
